import * as i0 from '@angular/core';
import { Injectable, Component, NgModule } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';

class EthanAbilitiesAngularSdk {
    constructor(http) {
        this.http = http;
        this.apiKey = '';
    }
    setApiKey(apiKey) {
        this.apiKey = apiKey; // Method to set API key
    }
    useEthanAbility(ability_slug, input) {
        // Below will be the API used for the ability
        return this.http.post(`https://ai.termsheet.com/api/v1/abilities/${ability_slug}/invoke`, input, {
            headers: new HttpHeaders({
                "x-api-key": this.apiKey,
            })
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.9", ngImport: i0, type: EthanAbilitiesAngularSdk, deps: [{ token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.9", ngImport: i0, type: EthanAbilitiesAngularSdk, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.9", ngImport: i0, type: EthanAbilitiesAngularSdk, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i1.HttpClient }] });

class EthanAbilitiesAngularSdkComponent {
    constructor() { }
    ngOnInit() {
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.9", ngImport: i0, type: EthanAbilitiesAngularSdkComponent, deps: [], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.9", type: EthanAbilitiesAngularSdkComponent, selector: "lib-ethan-abilities-angular-sdk", ngImport: i0, template: `
    <p>
      ethan-abilities-angular-sdk works!
    </p>
  `, isInline: true }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.9", ngImport: i0, type: EthanAbilitiesAngularSdkComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-ethan-abilities-angular-sdk', template: `
    <p>
      ethan-abilities-angular-sdk works!
    </p>
  ` }]
        }], ctorParameters: () => [] });

class EthanAbilitiesAngularSdkModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.9", ngImport: i0, type: EthanAbilitiesAngularSdkModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.9", ngImport: i0, type: EthanAbilitiesAngularSdkModule, declarations: [EthanAbilitiesAngularSdkComponent], exports: [EthanAbilitiesAngularSdkComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.9", ngImport: i0, type: EthanAbilitiesAngularSdkModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.9", ngImport: i0, type: EthanAbilitiesAngularSdkModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        EthanAbilitiesAngularSdkComponent
                    ],
                    imports: [],
                    exports: [
                        EthanAbilitiesAngularSdkComponent
                    ]
                }]
        }] });

/*
 * Public API Surface of ethan-abilities-angular-sdk
 */

/**
 * Generated bundle index. Do not edit.
 */

export { EthanAbilitiesAngularSdk, EthanAbilitiesAngularSdkComponent, EthanAbilitiesAngularSdkModule };
